var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 40",
    role: "img",
    "aria-label": "Catalan flag",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "#f4c400"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 60,
    height: 4,
    fill: "#c8102e"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 60,
    height: 4,
    fill: "#c8102e"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 60,
    height: 4,
    fill: "#c8102e"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 28,
    width: 60,
    height: 4,
    fill: "#c8102e"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 36,
    width: 60,
    height: 4,
    fill: "#c8102e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa);
export default __webpack_public_path__ + "static/media/ca.1d57dfae428f45f108ab7eb8c432f91a.svg";
export { ForwardRef as ReactComponent };